<div [hidden]="!ViewReady" [formGroup]="Section">
    <div *ngIf="Section.get('Instructions').value" class="centered margin-bottom">
        <span [innerHTML]="Section.get('Instructions')?.value | safeHTML"></span>
    </div>
    <ng-container formArrayName="Questions">
        <div *ngFor="let question of Section.get('Questions')?.controls; let i = index;" [formGroup]="question">
            <h2 *ngIf="question?.get('NarrativeText')?.value && question?.get('Text2')?.value == null" [innerHTML]="question?.get('NarrativeText')?.value"></h2>
            <p *ngIf="question?.get('NarrativeText')?.value && question?.get('Text2')?.value" [innerHTML]="question?.get('NarrativeText')?.value"></p>
			<ng-container [ngSwitch]="question?.get('QuestionType')?.value">
				<div *ngSwitchCase="'ShortResponse'" fxLayout="column" [ngClass]="{'inline': question?.get('Inline')?.value}">
					<div *ngIf="question?.get('Text2')?.value">
						<span *ngFor="let txt of question?.get('ExpandedText')?.value" [innerHTML]="displayText(txt)"></span>
					</div>
					<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
						<div>
							<span *ngIf="question?.get('ShowNumber')?.value">{{question?.get('QuestionNumber')?.value}}.</span>
							<span [innerHTML]="question?.get('QuestionText')?.value | safeHTML"></span>
						</div>
						<mat-form-field appearance="outline">
							<input type="text" matInput formControlName="Response" placeholder="Type here..." />
							<mat-hint *ngIf="question?.get('DigitOnly')?.value" [style.color]="question?.get('ResponseInvalid')?.value ? 'red' : 'black'">Numbers Only</mat-hint>
						</mat-form-field>
					</div>
				</div>
				<div *ngSwitchCase="'LongResponse'" class="margin-top">
					<div>
						<mat-icon *ngIf="Section.PrincipalOnly === true && IsNominee === true" title="This section is to be completed by your school principal or his/her designee.">lock</mat-icon>
						<span *ngIf="question?.get('ShowNumber')?.value">{{question?.get('QuestionNumber')?.value}}.</span>
						<span [innerHTML]="question?.get('QuestionText')?.value | safeHTML"></span>
					</div>
					<mat-form-field appearance="outline" class="fullwidth margin-top" [class.overLimit]="(question?.get('TextLimit')?.value != null && (question?.get('TextSizeCount')?.value || 0) > question?.get('TextLimit')?.value)">
						<textarea matInput formControlName="Response" placeholder="Type here..." rows="10"></textarea>
						<mat-hint *ngIf="question?.get('TextLimit')?.value != null && question?.get('LowerTextLimit')?.value != null" [style.color]="question?.get('TextSizeCount')?.value > question?.get('TextLimit')?.value || question?.get('TextSizeCount')?.value < question?.get('LowerTextLimit')?.value ? 'black' : 'limegreen'">Must be between {{question?.get('LowerTextLimit')?.value}} {{question?.get('TextLimitUnit')?.value | textUnit}} and {{question?.get('TextLimit')?.value}} {{question?.get('TextLimitUnit')?.value | textUnit}} ({{question?.get('TextSizeCount')?.value}} {{question?.get('TextLimitUnit')?.value | textUnit}})</mat-hint>
						<mat-hint *ngIf="question?.get('TextLimit')?.value != null && question?.get('LowerTextLimit')?.value == null" [style.color]="question?.get('TextSizeCount')?.value > question?.get('TextLimit')?.value ? 'red' : 'black'">Limit: {{question?.get('TextLimit')?.value}} {{question?.get('TextLimitUnit')?.value | textUnit}} ({{question?.get('TextSizeCount')?.value}} {{question?.get('TextLimitUnit')?.value | textUnit}})</mat-hint>
						<mat-hint *ngIf="question?.get('TextLimit')?.value == null && question?.get('LowerTextLimit')?.value != null" [style.color]="question?.get('TextSizeCount')?.value < question?.get('LowerTextLimit')?.value ? 'black' : 'limegreen'">Must be more than {{question?.get('LowerTextLimit')?.value}} {{question?.get('TextLimitUnit')?.value | textUnit}} ({{question?.get('TextSizeCount')?.value}} {{question?.get('TextLimitUnit')?.value | textUnit}})</mat-hint>
					</mat-form-field>
				</div>
				<div *ngSwitchCase="'YesNo'" fxLayout="row" fxLayoutAlign="start center" class="margin-top">
					<div *ngIf="question?.get('Text2')?.value == null">
						<mat-radio-group formControlName="Response" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px">
							<mat-radio-button [value]="'true'" color="primary">Yes</mat-radio-button>
							<mat-radio-button [value]="'false'">No</mat-radio-button>
						</mat-radio-group>
						<div fxFlex class="margin-left-double">
							<span *ngIf="question?.get('ShowNumber')?.value">{{question?.get('QuestionNumber')?.value}}.</span>
							<span [innerHTML]="question?.get('QuestionText')?.value | safeHTML"></span>
						</div>
					</div>
					<div *ngIf="question?.get('Text2')?.value" fxFlex="70" class="margin-bottom">
						<mat-radio-group formControlName="Response" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="15px" class="indent">
							<div>
								<mat-radio-button [value]="'true'" color="primary"></mat-radio-button>
								<span>{{question?.get('QuestionText')?.value}}</span>
							</div>
							<div>
								<mat-radio-button [value]="'false'"></mat-radio-button>
								<span>{{question?.get('Text2')?.value}}</span>
							</div>
						</mat-radio-group>
					</div>
				</div>
				<div *ngSwitchCase="'SingleCheckbox'" fxLayout="row" fxLayoutAlign="start center" class="margin-top">
					<mat-checkbox formControlName="Response" (change)="UpdateCheckbox($event, question)">
						<div>
							<span *ngIf="question?.get('ShowNumber')?.value">{{question?.get('QuestionNumber')?.value}}.</span>
							<span [innerHTML]="question?.get('QuestionText')?.value | safeHTML"></span>
						</div>
					</mat-checkbox>
				</div>
				<div *ngSwitchCase="'SelectionList'" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" class="margin-top">
					<div fxLayoutGap="15px">
						<span *ngIf="question?.get('ShowNumber').value">{{question?.get('QuestionNumber')?.value}}</span>
						<span [innerHTML]="question?.get('QuestionText')?.value | safeHTML"></span>
					</div>
					<mat-form-field appearance="outline" fxFlex="25">
						<mat-select formControlName="Response" placeholder="Select here...">
							<mat-option [value]="null">Select here...</mat-option>
							<mat-option *ngFor="let qOption of question?.get('Options')?.value" [value]="qOption.Value">{{qOption.DisplayText}}</mat-option>
						</mat-select>
					</mat-form-field>
					<mat-form-field appearance="outline" fxFlex="25" *ngIf="question?.get('OtherSelected').value">
						<input type="text" matInput formControlName="OtherResponse" placeholder="Type custom response here..." />
					</mat-form-field>
				</div>
				<div *ngSwitchCase="'MultiSelectionList'" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" class="margin-top">
					<div fxLayoutGap="15px">
						<span *ngIf="question?.get('ShowNumber').value">{{question?.get('QuestionNumber')?.value}}</span>
						<span [innerHTML]="question?.get('QuestionText')?.value | safeHTML"></span>
					</div>
					<mat-form-field appearance="outline" fxFlex="25">
						<mat-select multiple formControlName="Response" placeholder="Select here...">
							<mat-option [value]="null">Select here...</mat-option>
							<mat-option *ngFor="let qOption of question?.get('Options')?.value" [value]="qOption.Value">{{qOption.DisplayText}}</mat-option>
						</mat-select>
					</mat-form-field>
					<mat-form-field appearance="outline" fxFlex="25" *ngIf="question?.get('OtherSelected').value">
						<input type="text" matInput formControlName="OtherResponse" placeholder="Type custom response here..." />
					</mat-form-field>
				</div>
				<div *ngSwitchCase="'DatePicker'" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" class="margin-top">
					<div>
						<span *ngIf="question?.get('ShowNumber')?.value">{{question?.get('QuestionNumber')?.value}}.</span>
						<span [innerHTML]="question?.get('QuestionText')?.value | safeHTML"></span>
					</div>
					<mat-form-field appearance="outline" class="margin-top">
						<input matInput [matDatepicker]="i" formControlName="Response" readonly />
						<mat-datepicker-toggle matSuffix [for]="i"></mat-datepicker-toggle>
						<mat-datepicker #i disabled="false"></mat-datepicker>
					</mat-form-field>
				</div>
			</ng-container>
        </div>
    </ng-container>
</div>
